import { render, staticRenderFns } from "./TosfRequirementsList.vue?vue&type=template&id=1415c909&scoped=true"
import script from "./TosfRequirementsList.vue?vue&type=script&lang=js"
export * from "./TosfRequirementsList.vue?vue&type=script&lang=js"
import style0 from "./TosfRequirementsList.vue?vue&type=style&index=0&id=1415c909&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1415c909",
  null
  
)

export default component.exports